import { render, staticRenderFns } from "./profitLossLimit.vue?vue&type=template&id=a42c4b84&"
import script from "./profitLossLimit.vue?vue&type=script&lang=js&"
export * from "./profitLossLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports